import AutoAwesome from '@mui/icons-material/AutoAwesome';
import { Box, Button, CircularProgress, Paper, Stack } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import { StyledButton } from '../styles/StyledButtons';
import { StyledHeading, StyledTypography } from '../styles/styles';
import { DISCLAIMER_POINTS } from './constants';

export interface FundOpportunityChatDisclaimerProps {
  statusLoadError: boolean;
  isAcceptingDisclaimer: boolean;
  onRetryStatus: () => void;
  onAccept: () => void;
}

const FundOpportunityChatDisclaimer: React.FC<FundOpportunityChatDisclaimerProps> = ({
  statusLoadError,
  isAcceptingDisclaimer,
  onRetryStatus,
  onAccept,
}) => (
  <Box
    sx={{
      backgroundColor: '#ffffff',
      borderRadius: '32px',
      textAlign: 'left',
    }}
  >
    <Stack spacing={3}>
      <Stack direction="row" spacing={1} alignItems="center">
        <AutoAwesome fontSize="large" sx={{ color: Palette.default.buttonBg }} />
        <StyledHeading headerVariant="subheading" noTopPadding sx={{ fontSize: '1.75rem', mb: 0 }}>
          Vera AI
        </StyledHeading>
      </Stack>

      <Stack spacing={2}>
        {statusLoadError && (
          <Paper
            elevation={0}
            sx={{
              borderRadius: '16px',
              backgroundColor: '#fff5f5',
              border: '1px solid rgba(220, 38, 38, 0.2)',
              color: '#7f1d1d',
            }}
          >
            <StyledTypography sx={{ fontSize: '0.95rem', mb: 1 }}>
              We couldn't confirm your Vera access right now. Please try again.
            </StyledTypography>
            <Button
              variant="outlined"
              size="small"
              onClick={onRetryStatus}
              sx={{ textTransform: 'none' }}
            >
              Retry status check
            </Button>
          </Paper>
        )}
        <StyledTypography sx={{ color: Palette.default.text, fontSize: '1rem' }}>
          Welcome to Vera, Fides' AI powered assistant. Vera is an experimental feature, designed to
          help you explore and discuss investment opportunities. By using this feature, you
          acknowledge the following:
        </StyledTypography>

        <Box component="ul" sx={{ pl: 3, color: Palette.default.text, m: 0 }}>
          {DISCLAIMER_POINTS.map((point) => (
            <StyledTypography
              key={point}
              component="li"
              sx={{ mb: 1.5, fontSize: '1rem', lineHeight: 1.6 }}
            >
              {point}
            </StyledTypography>
          ))}
        </Box>

        <StyledTypography sx={{ color: Palette.default.text, fontSize: '1rem' }}>
          By interacting with the AI, you agree to use it for informational purposes only and not as
          a substitute for professional advice.
        </StyledTypography>
      </Stack>

      <Box sx={{ textAlign: 'center' }}>
        <StyledButton
          onClick={onAccept}
          disabled={isAcceptingDisclaimer}
          data-testid="vera-accept"
          buttonVariant="default"
        >
          {isAcceptingDisclaimer ? (
            <CircularProgress size={22} sx={{ color: 'white' }} />
          ) : (
            'Accept'
          )}
        </StyledButton>
      </Box>
    </Stack>
  </Box>
);

export default FundOpportunityChatDisclaimer;
